// removed by extract-text-webpack-plugin
module.exports = {"claim":"OekUZYUKlcIQ6Xe8YCLH"};


//////////////////
// WEBPACK FOOTER
// ./components/easinsure/claims/EasinsureClaimsListItem.scss
// module id = 1159
// module chunks = 0